import { render, staticRenderFns } from "./choose_patients.vue?vue&type=template&id=663dfff9&scoped=true&"
import script from "./choose_patients.vue?vue&type=script&lang=js&"
export * from "./choose_patients.vue?vue&type=script&lang=js&"
import style0 from "./choose_patients.vue?vue&type=style&index=0&id=663dfff9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663dfff9",
  null
  
)

export default component.exports